import react from "react";
import Button from "@mui/material/Button";
import styles from "./Button.module.css";
import Tooltip from "../Tooltip/Tooltip";

function Buttons(props) {
  return (
    <div className={styles.ButtonContainer}>
      <Tooltip
        TooltipText={props.tooltip}
        Tooltip={
          <Button
            href={props.link}
            disabled={props.disabled ? true : false}
            target={props.target}
            style={{
              background: props.buttonColor,
              color: props.color,
              height: props.height,
              fontSize: props.fontSize,
              fontWeight: props.fontWeight,
              border: props.border,
              width: props.width,
              minWidth:props.MinWidth,
              borderRadius: props.borderRadius,
              padding:props.padding,
            }}
            onClick={() =>
              typeof props.onClick !== "undefined" ? props.onClick() : {}
            }
            // download={props.download}
          >
            {props.icon && 
            <span style={{display:"flex", marginRight:props.IconSpace ? props.IconSpace  : "4px"}}>
            {props.icon}
            </span>
            }
            {props.label}
            {props.iconafter}
            {props.NotificationStatus && (
              <div className={styles.Notification}>{props.Notification}</div>
            )}
          </Button>
        }
      />

      {/* <Buttons
        label="Join for Free"
        buttonColor="#004FE0"
        color="#fff"
        height="60px"
        fontSize="20px"
        link=""
        onClick={onClick}
      /> */}
    </div>
  );
}

export default Buttons;
